import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import {
  ErrandCategory,
  ErrandCategoryDefaults,
  ErrandSubCategory,
} from '../../model/errand-category';

@Injectable()
export class ErrandCategoryService extends DataService<ErrandCategory> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ErrandCategory, progressBar, 'errand-category');
  }

  getCategoryDefaults(): Observable<ErrandCategoryDefaults> {
    return this.client.get<ErrandCategoryDefaults>(`${this.endpoint}/defaults`);
  }

  getSelectableList(filter: { isEnabled?: boolean | null }): Observable<ErrandCategory[]> {
    return this.client.post<ErrandCategory[]>(`${this.endpoint}/selectable/filter`, filter);
  }

  override mapFilterValue(key: string, value: any): any {
    if (key === 'isEnabled' && (value === '' || value === undefined)) {
      return null;
    }

    return super.mapFilterValue(key, value);
  }

  protected createModel(context: any): ErrandCategory {
    const model = super.createModel(context);
    if (Array.isArray(context.subcategories)) {
      model.subcategories = context.subcategories.map(item => new ErrandSubCategory(item));
    }
    return model;
  }
}
